<template>
	<div>
		<!-- 文本类型 -->
		<template v-if="(item.type === 'text' || item.type === 'checkbox-group') && level<2">
			<div
				:class="`text-level-${level} text-content`"
				style="text-align: left; width: 100%;"
			>
				<!-- 添加序号前缀 -->
				<span v-if="level === 0" class="level-number">
			  {{ getLevelNumber(num) }}、
		  </span>
				<span v-else-if="level === 1" class="level-number">
			  {{ num }}.
		  </span>
				{{item.title}}
			</div>
		</template>

		<!-- 单选选项 -->
		<template v-else-if="item.type === 'radio' && (item.rules || {is_show: true}).is_show">
			<van-radio
				:key="item.id"
				:icon-size=15
        :name="item.id"
        @click="(val) => {clickRadio(val, item)}"
			>
			<span class="option-text">
        <template v-if="item.title.indexOf('$input') !== -1">
          <template v-for="(txt, index) in item.title.split('$input')">
            {{txt}}
            <template v-if="index !== item.title.split('$input').length - 1">
              <input class="option-text-other" @blur="(e) => {blurOtherInput(e, item, index)}" :value="$store.getters.visitSurveyFormData[`other_${item.id}_${index}`] || ''" />
            </template>
          </template>
        </template>
        <template v-else>
          {{ item.title }}
        </template>
			</span>
			</van-radio>
		</template>

		<!-- 多选选项 -->
		<template v-else-if="item.type === 'checkbox' && ($store.getters.visitSurveyTopicRows.find(v => v.id === item.id).rules || {is_show: true}).is_show">
      <template v-if="item.title.indexOf('$input') !== -1">
        <van-checkbox
            :key="item.id"
            shape="square"
            class="custom-checkbox"
            :icon-size=15
            :name="item.id"
            label-disabled
            @click="(e) => {clickCheckbox(e, item)}"
        >
          <span class="option-text">
            <template v-for="(txt, index) in item.title.split('$input')">
              {{txt}}
              <template v-if="index !== item.title.split('$input').length - 1">
                <input class="option-text-other" @blur="(e) => {blurOtherInput(e, item, index)}" :value="$store.getters.visitSurveyFormData[`other_${item.id}_${index}`] || ''" />
              </template>
            </template>
          </span>
        </van-checkbox>
      </template>
      <template v-else>
        <van-checkbox
            :key="item.id"
            shape="square"
            class="custom-checkbox"
            :icon-size=15
            :name="item.id"
            label-disabled
            @click="(e) => {clickCheckbox(e, item)}"
        >
          <span class="option-text">{{ item.title }}</span>
        </van-checkbox>
      </template>
		</template>

		<!-- 单行输入框(input) -->
		<template v-else-if="item.type === 'input'">
      <van-field
          :label="item.title"
          class="single-input"
      >
        <template #input>
          <input :value="$store.getters.visitSurveyFormData[item.id]" placeholder="请输入" @blur="(e) => {blurInput(e, item)}" />
        </template>
      </van-field>
		</template>

		<!-- 多行输入框(textarea) -->
		<template v-else-if="item.type === 'textarea'">
			<van-field
        v-model="$store.getters.visitSurveyFormData[item.id]"
        @blur="(e) => {blurInput(e, item)}"
				:label="item.title"
				label-align="top"
				:label-width=" '100%' "
				type="textarea"
				rows="4"
				placeholder="请输入"
				class="multi-input"
			>
			</van-field>
		</template>

		<!-- 多选组 -->
		<template v-if="item.type === 'checkbox-group'">
			<div v-if="level>=2" class="group-title">{{item.title}}</div>
			<div class="choose-group">
				<van-checkbox-group
					v-model="$store.getters.visitSurveyFormData[item.id]"
					:direction="item.layout === 'inline' ? 'horizontal' : 'vertical'"
				>
					<template v-for="(v, i) in item.items">
						<topic
							:item="v"
							:level="level + 1"
							:num="i+1"
						/>
					</template>
				</van-checkbox-group>
			</div>
		</template>

		<!-- 单选组 -->
		<template v-else-if="item.type === 'radio-group'">
			<div class="group-title">{{item.title}}</div>
			<div class="choose-group">
				<van-radio-group
          v-model="$store.getters.visitSurveyFormData[item.id]"
					:direction="item.layout === 'inline' ? 'horizontal' : 'vertical'"
				>
					<template v-for="(v, i) in item.items">
						<topic
							:item="v"
							:level="level + 1"
							:num="i+1"
						/>
					</template>
				</van-radio-group>
			</div>
		</template>

		<!-- 其他类型 -->
		<template v-else>
			<template v-for="(v, i) in item.items">
				<topic
					:item="v"
					:level="level + 1"
					:num="i+1"
				/>
			</template>
		</template>
	</div>
</template>

<script>
import topic from './topic.vue';
import { RadioGroup, Radio, Checkbox, CheckboxGroup, Field } from 'vant';

export default {
	name: "topic",
	components: {
		topic,
		RadioGroup,
		Radio,
		Checkbox,
		CheckboxGroup,
		Field
	},
	props: {
		item: {
			type: [Object],
			default: () => ({
				id: '',  // 必须确保每个选项组有唯一ID
				title: "",
				type: '',
				items: []
			})
		},
		level: {
			type: [Number],
			default: 0
		},
		num: {
			type: [Number],
			default: 0
		}
	},
	data() {
		return {
			form_data: {},
		};
	},
	created() {
    this.form_data = this.$store.getters.visitSurveyFormData
	},
	methods: {
    changeRulesIsShowNode(){
      const rows = this.$store.getters.visitSurveyTopicRows
      const form_data = this.$store.getters.visitSurveyFormData

      const rules = rows.map(item => {
        if (!item.rules) {
          return item
        }
        if (!form_data[item.rules.condition[0]]) {
          return item
        }
        item.rules.is_show = !!(item.rules.condition.includes("=") && form_data[item.rules.condition[0]].includes(item.rules.condition[2]))
        return item
      })
      this.$store.dispatch("setFirstVisitSurveyTopicRows", rules)
    },
    changeCheckbox(v, item) {
      const form_data = JSON.parse(JSON.stringify(this.$store.getters.visitSurveyFormData))
      form_data[item.id] = v
      this.$store.dispatch("setFirstVisitSurveyFormData", form_data)
      this.changeRulesIsShowNode()
    },
    clickCheckbox(e, item) {
      // const form_data = JSON.parse(JSON.stringify(this.$store.getters.visitSurveyFormData))
      // console.log(form_data[item.pid])
      // this.$store.dispatch("setFirstVisitSurveyFormData", form_data)
    },
    changeRadio(v, item) {
      const form_data = this.$store.getters.visitSurveyFormData
      form_data[item.id] = v
      console.log(form_data)
      this.$store.dispatch("setFirstVisitSurveyFormData", form_data)
    },
    clickRadio(v, item) {
      const form_data = JSON.parse(JSON.stringify(this.$store.getters.visitSurveyFormData))
      form_data[item.pid] = item.id
      this.$store.dispatch("setFirstVisitSurveyFormData", form_data)
    },
    blurInput(e, item) {
      const form_data = JSON.parse(JSON.stringify(this.$store.getters.visitSurveyFormData))
      form_data[item.id] = e.target.value
      this.$store.dispatch("setFirstVisitSurveyFormData", form_data)
    },
    blurOtherInput(e, item, index) {
      const form_data = JSON.parse(JSON.stringify(this.$store.getters.visitSurveyFormData))
      form_data[`other_${item.id}_${index}`] = e.target.value
      this.$store.dispatch("setFirstVisitSurveyFormData", form_data)
    },
		// 获取层级序号
		getLevelNumber(num) {
			const chineseNumbers = ['一', '二', '三', '四', '五', '六', '七', '八'];
			return chineseNumbers[num-1];
		},
	}
};
</script>

<style scoped>
/*标题层级*/
.text-content {
	margin: 10px 0;
	font-weight: 500;
	color: #333;
}

.level-number {
	font-weight: 550;
	margin-right: 8px;
}

/* 一级标题（level=0） */
.text-level-0 {
	font-size: 32px;
	font-weight: 550;
	color: #4a478a; /* 主色调 */
	margin-top: 20px;
	margin-bottom: 15px;
}

/* 二级标题（level=1） */
.text-level-1 {
	font-size: 28px;
	font-weight: 550;
	color: #1e1f22;
	margin-left: 20px;
	margin-top: 15px;
	margin-bottom: 10px;
}

/*组标题样式*/
.group-title {
	font-size: 28px;
	font-weight: 500;
	color: #1e1f22;
	text-align: left;
	margin-left: 22px;
}

/* 单选/多选布局：根据layout */
.choose-group {
	margin-bottom: 15px;
	margin-left: 22px;
}

.option-input {
	width: 120px !important;
	margin-left: 12px;
}

/*.option-text {
	font-size: 27px;
	margin-left: -5px;
}*/

.van-radio {
	padding: 8px 0;
	margin-bottom: 5px; /* 增加选项间距，避免误触 */
}
.option-text {
	font-size: 27px;
	margin-left: 8px;
  display: inline-block;
  text-align: left;
}

.option-text-other {
  border-bottom: 1px solid;
  font-size: 0.7rem;
  width: 20%;
  display: inline-block;
}

/* 选中状态样式 有待修改?????????*/
.van-radio__icon--checked .van-icon {
	color: #4a478a !important;
	background-color: #ffffff;
}
.van-checkbox__icon--checked {
	background-color: #ffffff !important;
	border-color: #4a478a !important;
}
.van-checkbox__icon--checked .van-icon {
	color: #fff !important;
}


/* 单行输入框 */
.single-input >>>.van-field__label {
	font-size: 27px;
	width: auto;
	margin-right: 10px;
	color: #1e1f22;
}
.single-input >>>.van-field__control {
	font-size: 27px;
	color: #1e1f22;
	height: auto;
  border: 0;
	border-bottom: #787575 solid 1px;
	padding: 0 10px;
}

.single-input >>>.van-field__control input {
  font-size: 27px;
  color: #1e1f22;
  height: auto;
  border: 0;
  border-bottom: #787575 solid 1px;
  padding: 0 10px;
}


/* 多行输入框样式 */
.multi-input {
	margin-bottom: 15px;
	display: block !important;
}

/* 强制标签居上并占满一行 */
.multi-input >>>.van-field__label {
	text-align: left !important;
	margin-top: -17px;
	font-size: 27px;
	display: block !important;
	width: 100% !important;
	color: #1e1f22;
}

/* 输入区域样式调整 */
.multi-input >>>.van-field__body {
	width: 100% !important;
	margin-left: 0 !important;
}

.multi-input >>>.van-field__control {
	font-size: 27px;
	border: #787575 solid 1px;
	border-radius: 15px;
	padding: 10px;
}

</style>

